/*@flow*/
import type { Element } from 'react';
import React, { useContext } from 'react';
import Selection from './Selection';
import cx from 'classnames';
import StartButton from './Integration/StartButton';
import commands from './commands';
import BuilderContext from './Context';

const OtherSelection = ({ name, resourceName }) => {
  const ctx = useContext(BuilderContext);
  return (
    <a
      tabIndex={0}
      className={cx('mr-3', `resource-${resourceName}`)}
      onClick={() => {
        commands(ctx).selectResource(resourceName);
      }}
    >
      {name}
    </a>
  );
};

type PropsT = {
  requestClosePortal: Function,
};

export default (o: PropsT): Element<'div'> => (
  <div
    style={{
      minHeight: 300,
    }}
  >
    <div className="page-header d-flex mt-0">
      <h2 className="mt-0 mb-0">Manage the local data for this location </h2>
      <button
        className="ml-auto mr-1"
        onClick={() => {
          o.requestClosePortal();
        }}
      >
        <i className="fa fa-times text-muted" />
      </button>
    </div>
    <p className="mb-5 d-flex">
      <span>
        Make a new Page to keep track of the latest details about this location.
      </span>
      <StartButton className="ml-auto mr-3" />
    </p>
    <div>
      <h4 style={{ marginBottom: 0, fontWeight: 'bold' }}>
        STREETSCAPE DETAILS
      </h4>
      <div className="mt-3" style={{ width: '100%' }}>
        <Selection label="Streetscape Asset" resourceName="streetscape_asset" />
        <Selection label="Streetscape Issue" resourceName="streetscape_issue" />
      </div>
    </div>
    <div>
      <h4 style={{ marginTop: 20, marginBottom: 0, fontWeight: 'bold' }}>
        PROPERTY DETAILS
      </h4>
      <div>
        <div className="mt-3">
          <Selection label="Business or Attraction" resourceName="tenant" />
          <Selection label="Real Estate Listing" resourceName="listing" />
          <Selection label="Development Activity" resourceName="development" />
        </div>
      </div>
      <div>
        <div className="mt-3">
          <Selection label="Contact" resourceName="contact" />
          <Selection label="Property" resourceName="property" />
          <Selection label="Building" resourceName="building" />
        </div>
      </div>

      <div className="mt-5">
        <p>Add other types of records:</p>
        <div className="mt-3">
          {[
            ['unit', 'Unit'],
            ['event', 'Event'],
            ['organization', 'Organization'],
          ].map((arr, i) => (
            <OtherSelection
              name={arr[1]}
              resourceName={arr[0]}
              key={arr[0]}
              tabIndex={i}
            />
          ))}
        </div>
      </div>
    </div>
  </div>
);
